import React, { useEffect, useRef } from "react";
import insertScript from "helpers/insert-script";

const GorgiasHelpCenter = ({ data }) => {
  const { show } = data;
  const scriptContainerRef = useRef(null); 

  useEffect(() => {
    if (show && scriptContainerRef.current) {
      insertScript(
        scriptContainerRef.current, 
        "https://help-center.gorgias.help/api/help-centers/loader.js?v=2",
        "gorgias-help-center-script",
        false,
        true,
        {
          "data-gorgias-loader-help-center": "",
          "data-gorgias-help-center-uid": "5umy2q8n"
        }
      );
    }

    return () => {
      const scriptElement = document.getElementById("gorgias-help-center-script");
      if (scriptElement) {
        scriptElement.parentNode.removeChild(scriptElement);
      }
    };
  }, [show]);

  return (
    show && <div ref={scriptContainerRef} id="gorgias-help-center-root"></div>
  );
};

export default GorgiasHelpCenter;
